import React, { useState } from 'react';
import userImg from "../../Image/aboutimg.png"
import "../Dashborad/dashboard.css";
import "../DashboardLeft/Dashboard.css"
// E: \Tech - Xtend\Insight_Projects\UserPanel\Raaz_Work_Insight\src\jsx\DashboardLeft\Dashboard.css
import { FaNoteSticky } from "react-icons/fa6";
import { FaUserFriends } from "react-icons/fa";
import { FaWhatsapp } from "react-icons/fa";
import { BsFillCloudArrowDownFill } from "react-icons/bs";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Modal, Spinner } from 'react-bootstrap';
import { FaRupeeSign } from "react-icons/fa";
import 'bootstrap/dist/css/bootstrap.min.css';
import CivilModal from '../ReusableComponent/CIVIL/CivilModal/CivilModal';
import 'animate.css';
import axios from 'axios';
import { BASE_URL } from '../../insightConfig/insightConfig';
import swal from 'sweetalert';
function Dashboardleft2({ openPaymentModal, setOpenPaymentModal, testSeriesData, reloadTestData, setReloadTestData }) {
    // const [openPaymentModal, setOpenPaymentModal] = useState(false);
    const [modalBox, setModalBox] = useState(false)
    const location = useLocation();


    const storedAuthToken = localStorage.getItem('authtoken');
    const navigate = useNavigate()

    const testSeriesPrice = testSeriesData?.Price.toLocaleString('en-IN');
    const priceAfterDiscount = testSeriesData.Price - (testSeriesData.Price * (testSeriesData.Discount / 100))
    const payableAmount = Math.ceil(priceAfterDiscount)

    const handleEnroll = async () => {
        let data = { courseid: testSeriesData.CourseID, email: storedAuthToken, batchid: testSeriesData.BatchId, amount: 0, transactionid: "Free Test", status: 'Success' }
        if (payableAmount > 0) {
            if (storedAuthToken) {
                setOpenPaymentModal(true);
            } else {
                navigate('/login', { state: { from: location.pathname } });
            }

        } else {
            if (storedAuthToken) {
                const response = await axios.post(`${BASE_URL}/${'payordertest'}`, data);
                if (response.data.statusCode == 200) {
                    setReloadTestData(!reloadTestData)
                    swal('Enrolled Test Series Successfully', {
                        icon: "success",
                        buttons: {
                            confirm: {
                                text: "OK",
                                value: true,
                                visible: true,
                                closeModal: true
                            }
                        }
                    })

                }
            } else {
                navigate('/login', { state: { from: location.pathname } });
            }
        }


    }
    console.log('testSeriesData', testSeriesData);
    return (
        <>
            <div className='dashboardleft-background'>
                <div className='dash1'>
                    <img src={testSeriesData.Image || userImg} alt={"..."} className='dash2-img' />
                    <p className="fw-bold mb-1 border border-2 border-dark rounded rounded-2 w-100" style={{fontSize:"18px", color: '#333', fontFamily: 'Rubik, sans-serif', letterSpacing: '0.4px' }}>
                        <span className="text-primary me-2">Current Batch:</span>
                        <span style={{ color: '#FF6B00' }}>{testSeriesData?.BatchName}</span>
                    </p>
                    {testSeriesData.isEnrolled != 'enrolled' && <div className='d-flex justify-content-between w-100 my-2'>
                        
                        <button type="button" className="btn btn-darkblue"><FaNoteSticky className='me-1 fs-6' /> {testSeriesData.QuizCount} TESTS</button>
                        <button type="button" className="btn btn-darkblue"><FaUserFriends className='me-1 fs-6' /> {testSeriesData.SubscriberCount + testSeriesData.Subscriber} SUBS.</button>
                    </div>}
                </div>
                <div className='dash2'>
                    <div className="d-grid gap-2">
                        <Link to={testSeriesData.PDFUrl} className="btn d-flex align-item-center justify-content-center btn-orange fw-bold py-3" target='_blank' type="button"><BsFillCloudArrowDownFill className='me-1 fs-5' /> DOWNLOAD SCHEDULE</Link>

                        {testSeriesData.OtherTS_TitleURL ? (
                            <Link style={{ color: "#0B0B45" }} to={`/testseries/${testSeriesData.OtherTS_TitleURL}`} className="btn_custom_class btn d-flex align-items-center justify-content-center fw-bold py-3 text-white  text-uppercase fs-5" type="button">
                                {testSeriesData.Language === 'English' ?'हिंदी भाषा के लिए यहाँ क्लिक करें': 'CLICK HERE FOR ENGLISH LANGUAGE'} 
                                </Link>                            
                        ) : null}


                        {
                            testSeriesData.isEnrolled !== 'enrolled' ? (
                                <button
                                    onClick={handleEnroll}
                                    className="btn btn-orange w-100 py-3 d-flex flex-column align-items-center justify-content-center shadow-sm"
                                    type="button"
                                    style={{ borderRadius: '8px', border: 'none' }}
                                >
                                    <div className='d-flex align-items-center justify-content-center flex-wrap gap-2 mb-1' style={{ opacity: 0.9 }}>
                                        <span className='text-decoration-line-through text-uppercase underline-offset-2' style={{ fontSize: '0.9rem', letterSpacing: '0.5px' }}>
                                            FEE ₹{testSeriesPrice}
                                        </span>
                                        <span className='fw-bold text-uppercase' style={{ fontSize: '0.85rem', background: 'rgba(255,255,255,0.25)', padding: '2px 10px', borderRadius: '4px' }}>
                                            {testSeriesData.Discount || 0}% OFF
                                        </span>
                                        <span className='fw-bold' style={{ fontSize: '0.9rem' }}>
                                            PAY JUST ₹{payableAmount.toLocaleString('en-IN')}
                                        </span>
                                    </div>
                                    <div className='fw-bold text-uppercase' style={{ fontSize: '1.2rem', letterSpacing: '1.5px', textShadow: '0 1px 2px rgba(0,0,0,0.2)' }}>
                                        {payableAmount < 1 ? 'ENROLL FOR FREE' : `₹${payableAmount.toLocaleString('en-IN')} ENROLL NOW`}
                                    </div>
                                </button>
                            ) : (
                                <button className="btn btn-orange py-3 fw-bold text-uppercase" style={{ borderRadius: '8px', letterSpacing: '1.5px' }} type="button">ENROLLED</button>
                            )
                        }

                        <Link to="https://api.whatsapp.com/send?phone=91981833320" target='_blank' className="btn d-flex align-item-center justify-content-center bg-darkgreen fw-bold py-3" type="button"><FaWhatsapp className='me-1 fs-5' /> WHATSAPP 9818333201</Link>
                    </div>
                </div>
            </div>

            <Modal show={openPaymentModal} centered className="animate__animated animate__fadeIn mobileyoutube">
                <CivilModal paymentFor='testseries' payamount={payableAmount} BatchID={testSeriesData.BatchId} authtoken={storedAuthToken} CourseID={testSeriesData.CourseID} setOpen={setOpenPaymentModal} setModalBox={setModalBox} />
            </Modal>
            {/* <Modal show={isOpen4} centered className="animate__animated animate__fadeIn mobileyoutube">
                <CivilModal paymentFor='testseries' payamount={payableAmount} BatchID={testSeriesData.BatchId} authtoken={storedAuthToken} CourseID={testSeriesData.CourseID} closeModal={closeModal4} />
            </Modal> */}
            <Modal show={modalBox} top backdrop="static" dialogClassName="custom-modal-width">
                <div className="modal-content" style={{ backgroundColor: "#f0f8ff", padding: "2rem", borderRadius: "10px" }}>
                    <div className="modal-body" style={{ padding: "2rem" }}>
                        <div className="mb-3 d-block text-center">
                            <Spinner
                                animation="border"
                                className="mt-5 mb-3"
                                size="xl"
                                style={{ width: "200px", height: "200px", color: "#ff2f00" }}

                            />
                            <h5
                                className="modal-title mb-5"
                                id="exampleModalLabel"
                                style={{ color: "#17a2b8", fontFamily: "Arial, sans-serif" }}
                            >
                                Saving Order Details. This may take a moment...
                            </h5>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    )
}

export default Dashboardleft2; 